import {PlayerReduxState} from "../types";

export default function getExternalUserId(state: PlayerReduxState): string | null {
  return state.externalUserId ?? null;
}
